import React, { useContext, useEffect, useState } from 'react';
import { AmplifyAuthContext, AmplifyAuthSignoutContext } from '../App';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme,
} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import { API, Auth } from 'aws-amplify';
import { getAPIName } from '../config';
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApplicationRouter } from './routing.component';
import { NavMenuItem } from './NavItem';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Location } from '@reach/router';
import {
  List,
  Collapse,
  Divider,
  ListItem,
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
  Badge,
} from '@material-ui/core';

import {
  ExpandMore,
  ExpandLess,
  MoreHoriz,
  AccountCircle,
  Person,
  Business,
  ExitToApp,
  NotificationsNone,
  InsertDriveFileOutlined,
  Refresh,
} from '@material-ui/icons';
import { navigate } from '@reach/router';
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCar,
  faChartLine,
  faCog,
  faFile,
  faFolder,
  faHome,
  faLayerGroup,
  faListUl,
  faQuestion,
  faRoad,
  faUserTie,
  faUsers,
  faWarehouse,
  faCreditCard,
  faMagnifyingGlassDollar,
  faFileInvoiceDollar,
  faParking,
  faGear,
  faClipboardList,
  faRightFromBracket,
  faCarTunnel,
  faRoute
} from '@fortawesome/free-solid-svg-icons';
library.add(
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCar,
  faChartLine,
  faCog,
  faFile,
  faFolder,
  faHome,
  faLayerGroup,
  faListUl,
  faQuestion,
  faRoad,
  faUserTie,
  faUsers,
  faWarehouse,
  faFileInvoiceDollar,
  faParking,
  faGear,
  faClipboardList,
  faRightFromBracket,
  faCarTunnel,
  faRoute
);

const drawerWidth = 240;
const FAILED_FILES_MENU_MAX_HEIGHT = 420;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      backgroundColor: '#111218',
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
      textTransform: 'uppercase',
      fontSize: '0.9rem',
      textAlign: 'left',
      gap: theme.spacing(1),
      marginBottom:5
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    contactUsButton: {
      paddingRight: '0'
    },
    signOutButton: {
      paddingLeft: '0',
      width: '20px'
    },
    profileMenu: {
      '& .MuiListItemIcon-root': {
        minWidth: '32px',
      },
    },
    failedFilesPopoverPaper: {
      width: 320,
      maxWidth: 'calc(100vw - 16px)',
      maxHeight: FAILED_FILES_MENU_MAX_HEIGHT,
      borderRadius: 10,
      marginTop: theme.spacing(1),
      boxShadow: '0 10px 28px rgba(0,0,0,0.12)',
      overflow: 'hidden',
      backgroundColor: '#FFFFFF',
    },

    failedFilesBellButton: {
      cursor: 'pointer',
  },

    failedFilesHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1.25, 1.5),
      gap: theme.spacing(1),
    },

    failedFilesHeaderContent: {
      flex: 1,
    },

    failedFilesTitle: {
      fontSize: '0.86rem',
      fontWeight: 600,
      color: '#0F172A',
      letterSpacing: '-0.1px',
    },

    failedFilesSubtitle: {
      fontSize: '0.72rem',
      color: '#64748B',
      fontWeight: 500,
      marginTop: 1,
    },

    failedFilesRefresh: {
      width: 30,
      height: 30,
      borderRadius: 8,
      backgroundColor: '#FFFFFF',
      border: '1px solid #E2E8F0',
      color: '#475569',
      transition: 'all 0.2s ease',
      flexShrink: 0,
      '&:hover': {
        backgroundColor: '#F8FAFC',
        color: '#1E293B',
      },
      '&:active': {
        backgroundColor: '#F1F5F9',
      },
      '&.refreshing': {
        animation: '$spin 1s linear infinite',
      },
    },

    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },

    failedFilesContent: {
      maxHeight: FAILED_FILES_MENU_MAX_HEIGHT - 60,
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#E2E8F0',
        borderRadius: '3px',
        '&:hover': {
          backgroundColor: '#CBD5E1',
        },
      },
    },

    failedFilesAgency: {
      padding: theme.spacing(1.1, 1.5),
      borderBottom: '1px solid #E2E8F0',
      '&:last-child': {
        borderBottom: 'none',
      },
    },

    failedFilesAgencyHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(0.5),
    },

    failedFilesAgencyName: {
      fontSize: '0.78rem',
      fontWeight: 600,
      color: '#1E293B',
      letterSpacing: '-0.1px',
    },

    failedFilesCount: {
      minWidth: 20,
      height: 20,
      padding: '0 6px',
      borderRadius: 10,
      backgroundColor: '#FEE2E2',
      color: '#DC2626',
      fontSize: '0.68rem',
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      letterSpacing: '-0.2px',
    },

    failedFile: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: theme.spacing(0.25, 0),
      color: '#64748B',
      fontSize: '0.72rem',
      lineHeight: 1.4,
    },

    failedFileIcon: {
      color: '#94A3B8',
      fontSize: 14,
      flexShrink: 0,
    },

    failedFilesEmpty: {
      padding: theme.spacing(2.5, 1.5),
      textAlign: 'center',
      color: '#94A3B8',
      fontSize: '0.76rem',
      fontWeight: 500,
    },
  })
);

interface FailedTollFilesByAgency {
  agency: string;
  failedFiles: string[];
}

const normalizeFailedFilesByAgency = (rawData: any): FailedTollFilesByAgency[] => {
  if (!Array.isArray(rawData)) return [];
  return rawData
    .filter(
      (item): item is FailedTollFilesByAgency =>
        Boolean(item?.agency) && Array.isArray(item?.failedFiles) && item.failedFiles.length > 0
    )
    .map((item) => ({
      agency: item.agency,
      failedFiles: item.failedFiles,
    }));
};

export default function MiniDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const currentAuthenticatedUser: any = useContext(AmplifyAuthContext);
  const amplifyAuthSignout: any = useContext(AmplifyAuthSignoutContext);
  
  const [open, setOpen] = React.useState(true);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
  const [failedFilesAnchor, setFailedFilesAnchor] = useState<null | HTMLElement>(null);
  const [failedFiles, setFailedFiles] = useState<FailedTollFilesByAgency[]>([]);
  const [isLoadingFailedFiles, setIsLoadingFailedFiles] = useState(false);
  const isAdminUser = currentAuthenticatedUser?.attributes?.given_name === 'Admin';
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
  setProfileMenuAnchor(event.currentTarget);

  const closeProfileMenu = () => setProfileMenuAnchor(null);
  const closeFailedFilesMenu = () => setFailedFilesAnchor(null);

  const loadFailedFiles = async () => {
    setIsLoadingFailedFiles(true);
    try {
      const response: any = await API.get(getAPIName(), '/api/v1/failed_toll_files', {});
      const data: any = response?.data || response?.body?.data || response?.body || response;
      setFailedFiles(normalizeFailedFilesByAgency(data));
    } catch (error) {
      // Keep the notification menu usable even if the service is temporarily unavailable.
      setFailedFiles([]);
    } finally {
      setIsLoadingFailedFiles(false);
    }
  };

  const openFailedFilesMenu = (event: React.MouseEvent<HTMLElement>) => {
    setFailedFilesAnchor(event.currentTarget);
  };

  // Admin-only fetch so non-admin users do not request or see failed files.
  useEffect(() => {
    if (isAdminUser) {
      loadFailedFiles();
      return;
    }
    setFailedFiles([]);
  }, [isAdminUser]);

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }

  const signOut = async (): Promise<void> => {
    await Auth.signOut();
    amplifyAuthSignout();
  };
  const [sidebarCollapse, setSidebarCollapse] = useState<boolean>(false);
  const toggleSidebarCollapse = () => setSidebarCollapse(!sidebarCollapse);
  const userRole: string =
    currentAuthenticatedUser == null ||
      currentAuthenticatedUser.attributes == null ||
      currentAuthenticatedUser.attributes.given_name == null
      ? 'Individual'
      : currentAuthenticatedUser.attributes.given_name;

  const [dealershipOrGroupName, setDealershipOrGroupName] = useState<string | null>('');

  useEffect(() => {
    const { given_name: given, family_name: family } = currentAuthenticatedUser?.attributes || {};
    if (!['Individual', 'Group'].includes(given) || !family) {
      setDealershipOrGroupName('');
      return;
    }
    API.get(getAPIName(), `${given === 'Group' ? '/dealershipgroups' : '/dealerships'}?id=${encodeURIComponent(family)}`, {})
      .then((res) => setDealershipOrGroupName(res?.body?.[0]?.name || ''))
      .catch(() => setDealershipOrGroupName(''));
  }, [ currentAuthenticatedUser?.attributes?.given_name, currentAuthenticatedUser?.attributes?.family_name,]);

  const given = currentAuthenticatedUser?.attributes?.given_name;
  const userName =
  currentAuthenticatedUser?.attributes?.name ||
  currentAuthenticatedUser?.attributes?.email ||
  currentAuthenticatedUser?.username ||
  '';
  const appBarSubtitle = given === 'Admin' ? '  -  Admin' : dealershipOrGroupName
        ? `  -  ${dealershipOrGroupName}`
        : '';
  const failedFilesCount = failedFiles.reduce((count, agency) => count + agency.failedFiles.length, 0);
  const failedFilesStatusText = isLoadingFailedFiles
    ? 'Refreshing failed files...'
    : failedFilesCount > 0
      ? `${failedFiles.length} agencies · ${failedFilesCount} files`
      : 'No failed toll files right now';

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <FontAwesomeIcon icon={faAngleDoubleRight} />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title} >
            <img src="https://tollaid-emailtemplates.s3.us-east-2.amazonaws.com/DealershipLogos/logo-tollaid-white_red.png" alt="TollAid" height={30} width={65} />
            {appBarSubtitle}
          </Typography>
          <Button className={classes.contactUsButton} color="inherit" onClick={() => navigate('contact-us')}>
            Contact Us
          </Button>
        {isAdminUser && (
          <IconButton
            className={classes.failedFilesBellButton}
            color="inherit"
            aria-label="View failed toll files"
            aria-haspopup="true"
            onClick={openFailedFilesMenu}
            title={
              failedFilesCount === 0
                ? 'There are no failed toll files'
                : `${failedFilesCount} failed toll files`
            }
          >
            <Badge badgeContent={failedFilesCount} color="error" max={99} overlap="circular">
              <NotificationsNone />
            </Badge>
          </IconButton>
        )}
        <IconButton color="inherit" onClick={openProfileMenu}>
          <AccountCircle />
        </IconButton>

      {isAdminUser && (
      <Popover
        anchorEl={failedFilesAnchor}
        PaperProps={{ className: classes.failedFilesPopoverPaper }}
        open={Boolean(failedFilesAnchor)}
        onClose={closeFailedFilesMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className={classes.failedFilesHeader}>
          <div className={classes.failedFilesHeaderContent}>
            <Typography className={classes.failedFilesTitle}>
              Failed Toll Files
            </Typography>
            <Typography className={classes.failedFilesSubtitle}>
              {failedFilesStatusText}
            </Typography>
          </div>
          <IconButton
            className={`${classes.failedFilesRefresh} ${isLoadingFailedFiles ? 'refreshing' : ''}`}
            aria-label="Refresh failed toll files"
            size="small"
            onClick={loadFailedFiles}
            disabled={isLoadingFailedFiles}
            title="Refresh failed files"
          >
            <Refresh fontSize="small" />
          </IconButton>
        </div>

        <div className={classes.failedFilesContent}>
          {isLoadingFailedFiles ? (
            <Typography className={classes.failedFilesEmpty}>
              Loading failed files...
            </Typography>
          ) : failedFiles.length === 0 ? (
            <Typography className={classes.failedFilesEmpty}>
              No failed toll files
            </Typography>
          ) : (
            failedFiles.map((agency) => (
              <div
                key={agency.agency}
                className={classes.failedFilesAgency}
              >
                <div className={classes.failedFilesAgencyHeader}>
                  <Typography className={classes.failedFilesAgencyName}>
                    {agency.agency}
                  </Typography>
                  <span className={classes.failedFilesCount}>
                    {agency.failedFiles.length}
                  </span>
                </div>
                {agency.failedFiles.map((fileName) => (
                  <div
                    key={fileName}
                    className={classes.failedFile}
                  >
                    <InsertDriveFileOutlined
                      className={classes.failedFileIcon}
                    />
                    <span>{fileName}</span>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </Popover>
      )}

        <Menu
          anchorEl={profileMenuAnchor}
          className={classes.profileMenu}
          open={Boolean(profileMenuAnchor)}
          onClose={closeProfileMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem style={{cursor:'default'}}>
            <ListItemIcon>
              <Person />
            </ListItemIcon>
            <ListItemText primary={userName} />
          </MenuItem>

          <MenuItem style={{cursor:'default'}}>
            <ListItemIcon>
              <Business />
            </ListItemIcon>
            <ListItemText primary={given === 'Admin' ? 'Admin' : dealershipOrGroupName ?? 'N/A'} />
          </MenuItem>

          <MenuItem
            onClick={() => {
              closeProfileMenu();
              signOut();
            }}
          >
            <ListItemIcon>
              <ExitToApp color="error" />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </MenuItem>
        </Menu>
        </Toolbar>
      </AppBar>
    <Location>
      {({ location }) => (
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
        open={open}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? (
              <FontAwesomeIcon icon={faAngleDoubleRight} />
            ) : (
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          <NavMenuItem label="Dashboard" icon={faHome} route="" location={location}/>
          <NavMenuItem label="Contracts" icon={faListUl} route="contracts" location={location}/>
          <NavMenuItem label="Invoices" icon={faFile} route="invoices" location={location}/>
          <NavMenuItem label="Tolls" icon={faRoad} route="tolls" location={location}/>
          <NavMenuItem label="Authorize Payment" icon={faCreditCard} route="authorise" location={location}/>
          {/* Sidebar Collapse */}
          <Divider style={{ margin: '8px 0' }} />
          <ListItem button onClick={toggleSidebarCollapse}>
            <ListItemIcon><MoreHoriz /></ListItemIcon>
            <ListItemText primary={sidebarCollapse ? "Less" : "More"} />
            {sidebarCollapse ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          {/* Collapsible Section */}
          <Collapse in={sidebarCollapse} timeout="auto" unmountOnExit>
          <NavMenuItem label='ParkingTickets' icon={faParking} route="parkingtickets" location={location}/>
          {userRole === 'Admin' && (
            <NavMenuItem label="Toll Reports (Beta)" icon={faChartLine} route="tollreports" location={location}/>
          )}
          <NavMenuItem label="Financial Reports" icon={faFileInvoiceDollar}  route="financialreport" location={location}/>
          <NavMenuItem label="Vehicles" icon={faCar} route="vehicles" location={location}/>
          {userRole === 'Admin' && (<NavMenuItem label="Dealership Controls" icon={faGear} route="dealershipcontrols" location={location} /> )}
          {/*<NavMenuItem label="Employees" icon={faUserTie} route="employees" />*/}
          {userRole === 'Admin' && (
            <NavMenuItem
              label="Groups"
              icon={faLayerGroup}
              route="dealership-groups"
              location={location}
            />
          )}
          {(userRole === 'Admin' || userRole === 'Group') && (
            <React.Fragment>
              <NavMenuItem
                label="Locations"
                icon={faWarehouse}
                route="dealerships"
                location={location}
              />

              <NavMenuItem label="Users" icon={faUsers} route="users" location={location}/>
            </React.Fragment>
          )}
          {userRole === 'Admin' && (
            <NavMenuItem
              label="TollRates"
              icon={faMagnifyingGlassDollar}
              route="tollrates"
              location={location}
            />
          )}
            <NavMenuItem
              label="Violations"
              icon={faClipboardList}
              route="violations"
              location={location}
            />
          {/*
          <NavMenuItem label="Paper Violations" icon={faFolder} route="paper-violations" />
          <NavMenuItem label="Fleet" icon={faCar} route="fleet" />
          <NavMenuItem label="reports" icon={faChartLine} route="reports" />
          */}
          <NavMenuItem label="Toll Calculator" icon={faRoute} route="toll-calculator" location={location}/>
          </Collapse>
        </List>
        {/*
        <Divider />
        <NavMenuItem label="Help & Support" icon={faQuestion} route="help-support" />
        */}
      </Drawer>
       )}
      </Location>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <ApplicationRouter userRole={userRole}/>
      </main>
    </div>
  );
}
